module.exports = __webpack_public_path__ + "img/teilnehmer-skikurs_02.dc52cd3b.svg";